// Copyright © 2025 The Things Industries B.V.

import {
  createPaginationBaseActionType,
  createPaginationDeleteActions,
  createPaginationDeleteBaseActionType,
  createPaginationRequestActions,
} from '@ttn-lw/lib/store/actions/pagination'
import createRequestActions from '@ttn-lw/lib/store/actions/create-request-actions'

export const SHARED_NAME = 'LABEL'

export const GET_LABEL_LIST_BASE = createPaginationBaseActionType(SHARED_NAME)
export const [
  { request: GET_LABEL_LIST, success: GET_LABEL_LIST_SUCCESS, failure: GET_LABEL_LIST_FAILURE },
  { request: getLabelList, success: getLabelListSuccess, failure: getLabelListFailure },
] = createPaginationRequestActions(SHARED_NAME)

export const CREATE_LABEL_BASE = 'CREATE_LABEL'
export const [
  { request: CREATE_LABEL, success: CREATE_LABEL_SUCCESS, failure: CREATE_LABEL_FAILURE },
  { request: createLabel, success: createLabelSuccess, failure: createLabelFailure },
] = createRequestActions(CREATE_LABEL_BASE, label => ({ label }))

export const UPDATE_LABEL_BASE = 'UPDATE_LABEL'
export const [
  { request: UPDATE_LABEL, success: UPDATE_LABEL_SUCCESS, failure: UPDATE_LABEL_FAILURE },
  { request: updateLabel, success: updateLabelSuccess, failure: updateLabelFailure },
] = createRequestActions(UPDATE_LABEL_BASE, (id, patch) => ({ id, patch }))

export const DELETE_LABEL_BASE = createPaginationDeleteBaseActionType(SHARED_NAME)
export const [
  { request: DELETE_LABEL, success: DELETE_LABEL_SUCCESS, failure: DELETE_LABEL_FAILURE },
  { request: deleteLabel, success: deleteLabelSuccess, failure: deleteLabelFailure },
] = createPaginationDeleteActions(SHARED_NAME, id => ({ id }))

export const GET_LABEL_BASE = 'GET_LABEL'
export const [
  { request: GET_LABEL, success: GET_LABEL_SUCCESS, failure: GET_LABEL_FAILURE },
  { request: getLabel, success: getLabelSuccess, failure: getLabelFailure },
] = createRequestActions(
  GET_LABEL_BASE,
  id => ({ id }),
  (id, selector, options = {}) => ({ selector, options }),
)

export const GET_LABEL_ENTITIES_BASE = 'GET_LABEL_ENTITIES'
export const [
  {
    request: GET_LABEL_ENTITIES,
    success: GET_LABEL_ENTITIES_SUCCESS,
    failure: GET_LABEL_ENTITIES_FAILURE,
  },
  { request: getLabelEntities, success: getLabelEntitiesSuccess, failure: getLabelEntitiesFailure },
] = createRequestActions(GET_LABEL_ENTITIES_BASE, (label, options) => ({ label, options }))
